module.exports = __webpack_public_path__ + "img/NeonRoute596.dfdb8fc9.png";